export const productAvailabilityModule = {
  getters: {
    getChosenProduct: (state, getters, rootState) => {
      const chosenOrder = rootState.orders.selectedOrder;
      return chosenOrder.product;
    },
  },
};
